import { IGetOnboardingFlowResponse } from '@Saral-Influencer-Marketing/saral-utils/src/types';
import { Dispatch } from 'redux';

import { getAllOnboardingVideos, updateOnboardingStepProgress } from '../../services/onboardingVideos.service';
import {
  FETCH_ONBOARDING_VIDEOS_FAILURE,
  FETCH_ONBOARDING_VIDEOS_REQUEST,
  FETCH_ONBOARDING_VIDEOS_SUCCESS,
  OnboardingVideosActionTypes,
  UPDATE_ONBOARDING_VIDEO_STEP_PROGRESS,
} from './onboardingVideosTypes';

export const fetchOnboardingVideosRequest = (): OnboardingVideosActionTypes => {
  return {
    type: FETCH_ONBOARDING_VIDEOS_REQUEST,
  };
};

export const fetchOnboardingVideosSuccess = (videos: IGetOnboardingFlowResponse): OnboardingVideosActionTypes => {
  return {
    type: FETCH_ONBOARDING_VIDEOS_SUCCESS,
    payload: videos,
  };
};

export const fetchOnboardingVideosFailure = (error: string): OnboardingVideosActionTypes => {
  return {
    type: FETCH_ONBOARDING_VIDEOS_FAILURE,
    payload: error,
  };
};

export const updateStepCompletionStatus = (stepId: string, isCompleted: boolean): OnboardingVideosActionTypes => {
  return {
    type: UPDATE_ONBOARDING_VIDEO_STEP_PROGRESS,
    payload: { stepId, isCompleted },
  };
};

export const fetchOnboardingVideos = () => {
  return async (dispatch: Dispatch<OnboardingVideosActionTypes>) => {
    dispatch(fetchOnboardingVideosRequest());
    try {
      const response = await getAllOnboardingVideos();
      dispatch(fetchOnboardingVideosSuccess(response.data.data));
    } catch (error) {
      const errorMessage = error instanceof Error ? error.message : 'An unknown error occurred';
      dispatch(fetchOnboardingVideosFailure(errorMessage));
    }
  };
};

export const updateOnboardingVideoStepProgress = (stepId: string, body: any) => {
  return async (dispatch: Dispatch<any>) => {
    try {
      const response = await updateOnboardingStepProgress(stepId, body);
      if (response?.status) {
        dispatch(fetchOnboardingVideos());
      }
    } catch (error) {
      console.error('Error updating onboarding step progress:', error);
    }
  };
};
